import React from 'react';
import { shape, string } from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Button, Loader } from 'components';
import TextInput from 'components/Inputs/TextInput/TextInputV2';
import { useGeneralGroupSettings } from './hooks';
import { FIELDS } from './form';

import { StyledWrapper, StyledButtonBlock } from './styled';
import { getDateStringWithDay } from 'utils/dates';

const SettingsGeneral = ({ group, isLoading }) => {
  const { t } = useTranslation();
  const { onSubmit, register, errors } = useGeneralGroupSettings(group);

  return (
    <StyledWrapper>
      <form onSubmit={onSubmit}>
        <TextInput
          register={register}
          name={FIELDS.GROUP_NAME}
          width="100%"
          label={t('group.groupName')}
          error={errors[FIELDS.GROUP_NAME]}
        />
        <TextInput
          register={register}
          defaultValue={getDateStringWithDay(new Date(group?.createdAt), t)}
          name={t('common.createdAt')}
          width="100%"
          disabled
          label={t('common.createdAt')}
        />
        <TextInput
          register={register}
          defaultValue={getDateStringWithDay(new Date(group?.updatedAt), t)}
          name={t('common.updatedAt')}
          width="100%"
          disabled
          label={t('common.updatedAt')}
        />
        <StyledButtonBlock>
          <Button
            type="submit"
            variant={isLoading ? 'secondary' : null}
            disabled={isLoading}
          >
            {isLoading ? (
              <Loader type="button" size="28px" thickness={2} />
            ) : (
              t('common.saveChanges')
            )}
          </Button>
        </StyledButtonBlock>
      </form>
    </StyledWrapper>
  );
};

SettingsGeneral.propTypes = {
  group: shape({
    name: string,
  }).isRequired,
};

export default SettingsGeneral;
